import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

import { type ApiResponse, put } from "../../../api/api";

export const COMPLETE_SIGNUP_PATH = "/onboarding/completeSignup";

const completeSignupResponseSchema = z.object({ success: z.boolean() });
type CompleteSignupResponse = z.infer<typeof completeSignupResponseSchema>;

export function useCompleteSignup(
  options: UseMutationOptions<ApiResponse<CompleteSignupResponse>, AxiosError> = {}
) {
  return useMutation({
    mutationFn: async () => {
      return await put({
        url: COMPLETE_SIGNUP_PATH,
        responseSchema: completeSignupResponseSchema,
      });
    },
    ...options,
  });
}
